import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";

function Selectedroleaccess({ close }) {
  return (
    <div className="AddnewsupportTicket relative">
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className=" text-[#77498F] font-bold text-[2rem] leading-[3.2rem] text-center">
        دسترسی های استاد
      </h3>
      <div className=" w-[40rem] mt-[2.6rem]">
        {rolles.map((item, id) => (
          <p className=" text-[#21212199] text-[1.8rem] font-normal leading-[3.2rem] mb-[0.9rem]">
            <span>{id + 1}-</span> {item.text}
          </p>
        ))}
      </div>
      <div className=" text-left mt-[2.8rem]">
        <BtnPrimary text="تایید دسترسی" className="px-16 py-7" />
      </div>
    </div>
  );
}

export default Selectedroleaccess;
const rolles = [
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
  { text: "لورم ایپسوم" },
];
